/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Luci_Shopping_Api_Models_AddressWithName } from './Luci_Shopping_Api_Models_AddressWithName';
import type { Luci_Shopping_Api_Models_OrderFulfillment } from './Luci_Shopping_Api_Models_OrderFulfillment';
import type { Luci_Shopping_Api_Models_OrderLineItem } from './Luci_Shopping_Api_Models_OrderLineItem';
import type { Luci_Shopping_Api_Models_StoreCustomer } from './Luci_Shopping_Api_Models_StoreCustomer';
export type Luci_Shopping_Api_Models_OrderModel = {
  id?: number;
  tenantId?: number;
  storeId?: number;
  eventId?: number;
  receiptNotes?: string;
  notes?: string;
  source?: Luci_Shopping_Api_Models_OrderModel.source;
  lineItems?: Array<Luci_Shopping_Api_Models_OrderLineItem>;
  orderTotal?: number;
  lineItemSubtotal?: number;
  customer?: Luci_Shopping_Api_Models_StoreCustomer;
  shippingProviderId?: number;
  shippingTaxAmount?: number;
  salesTaxAmount?: number;
  shippingAmount?: number;
  created?: string;
  cancelled?: string;
  completed?: string;
  finalized?: string;
  paid?: string;
  invoicePaymentDueDate?: string;
  shipToAddress?: Luci_Shopping_Api_Models_AddressWithName;
  billingAddress?: Luci_Shopping_Api_Models_AddressWithName;
  isReturnOrder?: boolean;
  returnedOrderId?: number;
  chargeTax?: boolean;
  status?: Luci_Shopping_Api_Models_OrderModel.status;
  fulfillmentMethod?: Luci_Shopping_Api_Models_OrderModel.fulfillmentMethod;
  fulfillment?: Luci_Shopping_Api_Models_OrderFulfillment;
  isShippingAmountOverriden?: boolean;
  transactionId?: string;
  invoiced?: boolean;
  isPastDue?: boolean;
  invoiceGracePeriod?: string;
};
export namespace Luci_Shopping_Api_Models_OrderModel {
  export enum source {
    UNKNOWN = 'Unknown',
    PERSONAL_USE = 'PersonalUse',
    APP = 'App',
    WEBSITE = 'Website',
    REPLY_TO_BUY = 'ReplyToBuy',
  }
  export enum status {
    OPEN = 'Open',
    CANCELLED = 'Cancelled',
    COMPLETED = 'Completed',
    FINALIZED = 'Finalized',
    RETURNED = 'Returned',
    INVOICED = 'Invoiced',
    PAID = 'Paid',
  }
  export enum fulfillmentMethod {
    POINT_OF_SALE = 'PointOfSale',
    SHIPPING = 'Shipping',
    PICKUP = 'Pickup',
  }
}

